// App.jsx
import React, { useState, useCallback } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Header from "./components/Header";
import Carousel from "./components/Carousel";
import CompanyIntro from "./components/CompanyIntro";
import CompanyHighlight from "./components/CompanyHighlight";
import Products from "./components/Products";
import BatteryCategory from "./components/BatteryCategory";
import BatteryDetail from "./components/BatteryDetail";
import Testimonials from "./components/Testimonials";
import ContactForm from "./components/ContactForm";
import Footer from "./components/Footer";
import RevealSection from "./components/RevealSection";
import ScrollToTop from "./components/ScrollToTop";
import SplashScreen from "./components/SplashScreen";

function App() {
  const [splashDone, setSplashDone] = useState(
    () => sessionStorage.getItem("splashShown") === "1"
  );

  const handleSplashDone = useCallback(() => {
    setSplashDone(true);
    sessionStorage.setItem("splashShown", "1");
  }, []);

  return (
    <Router>
      {!splashDone && <SplashScreen onDone={handleSplashDone} />}
      <ScrollToTop />
      <div className="App">
        <Header />
        <Routes>
          <Route
            path="/"
            element={
              <>
                <Carousel />
                <RevealSection id="about">
                  <CompanyIntro />
                </RevealSection>
                <RevealSection id="technology">
                  <CompanyHighlight />
                </RevealSection>
                <RevealSection id="products">
                  <Products />
                </RevealSection>
                <RevealSection id="testimonials">
                  <Testimonials />
                </RevealSection>
                <RevealSection id="contact">
                  <ContactForm />
                </RevealSection>
              </>
            }
          />
          <Route path="/category/:categoryName" element={<BatteryCategory />} />
          <Route
            path="/battery/:categoryName/:batteryId"
            element={<BatteryDetail />}
          />
        </Routes>
        <RevealSection>
          <Footer />
        </RevealSection>
      </div>
    </Router>
  );
}

export default App;
